import { Tag } from '@cian/components';
import * as React from 'react';

import { IBedroomsMinCountTag } from '../../../state/tags/definitions/bedrooms_min_count';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IBedroomsMinCountTagItemProps {
  tag: IBedroomsMinCountTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const BedroomsMinCountTagItem = ({ tag, onDeleteClick, withNewTag }: IBedroomsMinCountTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {`Спален минимум ${tag.value}`}
    </TagComponent>
  );
};
